import { useTeam } from 'app/frontend/base/config/context/team'
import { useContext } from 'react'
import { LootContext } from '../context'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import Difficulty, {
  difficulties,
  difficultiesILVLDeficit,
} from 'app/frontend/types/custom/Difficulty'

type Props = {
  setToAll?: (value: boolean) => void
  setAsAll?: boolean
  className?: string
  unrestricted?: boolean
}

const DifficultySelector = ({
  setToAll,
  setAsAll,
  className,
  unrestricted,
}: Props) => {
  const { team } = useTeam()

  const { difficulty, setDifficulty } = useContext(LootContext)
  const availableDifficulties = unrestricted
    ? difficulties.filter((diff) => diff !== 'raid_finder')
    : difficulties.filter((diff) =>
        team.settings.wishlistDifficulties.value.includes(diff),
      )
  const showSelector = unrestricted || availableDifficulties.length > 1

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {showSelector && (
        <>
          <span className='font-semibold'>Difficulty</span>
          <div>
            <Tabs
              value={setAsAll ? 'all' : difficulty}
              onValueChange={(value) => {
                if (value === 'all') {
                  setToAll?.(true)
                } else {
                  setToAll?.(false)
                  setDifficulty(value as Difficulty)
                }
              }}
            >
              <TabsList>
                {availableDifficulties.map((diff) => (
                  <TabsTrigger key={diff} value={diff}>
                    {
                      Object.keys(difficultiesILVLDeficit)[
                        difficulties.indexOf(diff)
                      ]
                    }
                  </TabsTrigger>
                ))}
                {setToAll && <TabsTrigger value={'all'}>All</TabsTrigger>}
              </TabsList>
            </Tabs>
          </div>
        </>
      )}
    </div>
  )
}

export default DifficultySelector
